import React from "react";
import { Select, Typography } from "antd";
import { useSelector } from "react-redux";
import { getAvailableBranches } from "./functions";

/**
 * Editor das origens da junção (`config.sources`): quais caminhos do desvio
 * voltam a ser um só a partir deste passo.
 *
 * As opções vêm dos caminhos declarados antes deste passo — os mesmos do
 * seletor "Executar somente no caminho" —, limitadas ao escopo em que a
 * própria junção executa: unir um caminho de fora dele seria pedir para a
 * junção ser alcançada por uma rota que o `branch` dela já exclui, e o
 * salvamento recusaria.
 */
export const MergeSourcesEditor = ({ value, onChange }) => {
    const { actions, actionStep } = useSelector(({ automation }) => automation);
    const action = actions?.[actionStep] ?? {};
    const scope = action.branch ?? null;
    const sources = Array.isArray(value) ? value : [];

    const available = getAvailableBranches(actions ?? [], actionStep).filter(
        (item) => scope === null || item.value.startsWith(`${scope}.`)
    );

    const options = available.map((item) => ({
        value: item.value,
        label: `${item.label} — ${item.switchName}`,
    }));

    // Caminho órfão (desvio removido, renomeado fora daqui ou movido para
    // depois da junção): mantém visível para o usuário poder tirar da lista.
    sources
        .filter((source) => !available.some((item) => item.value === source))
        .forEach((source) =>
            options.push({ value: source, label: `${source} (caminho inexistente!)` })
        );

    return (
        <div>
            <Select
                mode="multiple"
                style={{ width: "100%" }}
                placeholder="Escolha os caminhos que se unem aqui"
                value={sources}
                options={options}
                onChange={onChange}
            />
            {options.length === 0 && (
                <Typography.Paragraph type="warning" style={{ fontSize: 12, marginTop: 8 }}>
                    Não há caminhos disponíveis: a junção precisa vir depois de um
                    desvio, e fora dos caminhos que ela une (deixe "Sempre executa" em
                    Execução).
                </Typography.Paragraph>
            )}
            {options.length > 0 && sources.length < 2 && (
                <Typography.Paragraph type="warning" style={{ fontSize: 12, marginTop: 8 }}>
                    Uma junção precisa unir pelo menos 2 caminhos.
                </Typography.Paragraph>
            )}
            <div className="ae-hint">
                Os caminhos escolhidos passam a seguir juntos: os passos ligados à
                junção executam uma única vez, para qualquer um deles. Os caminhos
                de fora continuam separados — para reunir todos, basta um passo sem
                caminho ("Sempre executa").
            </div>
        </div>
    );
};
